import script from "./Beneficios.vue?vue&type=script&setup=true&lang=js"
export * from "./Beneficios.vue?vue&type=script&setup=true&lang=js"

import "./Beneficios.vue?vue&type=style&index=0&id=140fef98&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140fef98"]])

export default __exports__